module.exports = __webpack_public_path__ + "img/capacitor-purple.89e4f486.png";